import { render, staticRenderFns } from "./SvgInforCard.vue?vue&type=template&id=bf2b6dac&"
import script from "./SvgInforCard.vue?vue&type=script&lang=js&"
export * from "./SvgInforCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports